import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["elapsed"]

  connect() {
    if (this.hasElapsedTarget) {
      this.startedAt = new Date(this.elapsedTarget.dataset.startedAt)
      this.tick()
      this.interval = setInterval(() => this.tick(), 1000)
    }
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  tick() {
    const now = new Date()
    const diff = Math.floor((now - this.startedAt) / 1000)
    const hours = Math.floor(diff / 3600)
    const minutes = Math.floor((diff % 3600) / 60)
    const seconds = diff % 60
    const pad = (n) => String(n).padStart(2, "0")
    this.elapsedTarget.textContent = `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
  }
}
